import { msg } from "@lingui/core/macro";

export const vehiclesAreUniqueRuleMessages = {
	name: msg({ message: "Vehicles are Unique" }),
	description: msg({ message: "Permit must not have duplicated plates" }),
	errors: {
		duplicatePlates: msg({ message: "Permit contains duplicate plates: ({plates})" }),
	},
} as const;
